/**
 * useTheme — applies CSS variable palettes per page.
 * Each page has its own colour theme set on :root so all
 * CSS variables update instantly when you switch pages.
 */

const PALETTES = {
  today: {
    '--bg':     '#EEF5EE',
    '--surf':   '#D9EDD9',
    '--stone':  '#8FBD8F',
    '--bark':   '#2E7D3E',
    '--ink':    '#0D2B12',
    '--accent': '#238b45',
    '--sage':   '#52A96A',
    '--gold':   '#A8C96A',
  },
  challenges: {
    '--bg':     '#F5EEF8',
    '--surf':   '#E8D9EE',
    '--stone':  '#B48DC4',
    '--bark':   '#6B3D8A',
    '--ink':    '#1E0D2B',
    '--accent': '#7B4EAB',
    '--sage':   '#9E6EC8',
    '--gold':   '#C4A0D8',
  },
  reading: {
    '--bg':     '#FDF5E6',
    '--surf':   '#F5E6C8',
    '--stone':  '#C4A87A',
    '--bark':   '#7A5A2E',
    '--ink':    '#2B1E0D',
    '--accent': '#A0722A',
    '--sage':   '#C49A4A',
    '--gold':   '#D4B06A',
  },
  writing: {
    '--bg':     '#F8EEF0',
    '--surf':   '#F0D9DE',
    '--stone':  '#C48A96',
    '--bark':   '#782840',
    '--ink':    '#2E0A14',
    '--accent': '#A03050',
    '--sage':   '#C85070',
    '--gold':   '#D4A0A8',
  },
  teal: {
    '--bg':     '#EBF5F5',
    '--surf':   '#D0EBEB',
    '--stone':  '#7ABABA',
    '--bark':   '#2A6868',
    '--ink':    '#0A2020',
    '--accent': '#2A8A8A',
    '--sage':   '#4AABAB',
    '--gold':   '#8ACACA',
  },
}

const PAGE_THEMES = {
  // New page IDs
  'dashboard':              PALETTES.today,
  'wellbeing':              PALETTES.teal,
  'wellbeing/mood':         PALETTES.today,
  'wellbeing/activity':     PALETTES.teal,
  'wellbeing/trends':       PALETTES.teal,
  'wellbeing/reflections':  PALETTES.teal,
  'hobbies/gardening':      PALETTES.teal,
  'hobbies/cooking':        PALETTES.teal,
  'hobbies/writing':        PALETTES.writing,
  'hobbies/reading':        PALETTES.reading,
  'hobbies/journaling':     PALETTES.teal,
  'challenges':             PALETTES.teal,
  'challenges/active':      PALETTES.teal,
  'challenges/explore':     PALETTES.challenges,
  'challenges/vault':       PALETTES.teal,
  'challenges/completed':   PALETTES.teal,
  'my-space':               PALETTES.teal,
  'my-space/pages':         PALETTES.teal,
  'my-space/trackers':      PALETTES.teal,
  'my-space/goals':         PALETTES.teal,
  // Legacy keys kept so any direct references still resolve
  'daily-summary': PALETTES.today,
  'activities':    PALETTES.teal,
  'gardening':     PALETTES.teal,
  'cooking':       PALETTES.teal,
  'reading':       PALETTES.reading,
  'journaling':    PALETTES.teal,
  'goals':         PALETTES.teal,
  'writing':       PALETTES.writing,
  'learning':      PALETTES.teal,
  today:           PALETTES.today,
}

export function useTheme() {
  function applyTheme(pageName) {
    const theme = PAGE_THEMES[pageName]
    if (!theme) return
    const root = document.documentElement.style
    Object.entries(theme).forEach(([key, value]) => root.setProperty(key, value))
  }

  return { applyTheme, PAGE_THEMES }
}
